import * as React from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import Tooltip from "@material-ui/core/Tooltip";
import Error from '@material-ui/icons/Error';
import {TextField, withStyles} from "@material-ui/core";
import {ReachElement, Svhc} from "../../store/reach/types";
import {compose} from "redux";
import {WithTranslation, withTranslation} from "react-i18next";

type Props = WithTranslation & {
    svhc: Svhc;
    element: ReachElement;
    propName: string;
    handleChange: (substanceId: number, propName: string) => (event: React.ChangeEvent) => void;
}

class ReachTextField extends React.Component<Props, {}> {
    render() {
        const svhc = this.props.svhc;
        const element = this.props.element;
        const propName = this.props.propName;
        const valPropName = propName + 'Validation';
        const t = this.props.t;
        return (
            <TextField margin="normal"
                       defaultValue={element[propName] ? element[propName]!.toString() : ''}
                       onChange={this.props.handleChange(svhc.id, propName)}
                       error={element[valPropName] != undefined && (element[valPropName] as string[]).length > 0}
                       InputProps={element[valPropName] && (element[valPropName] as string[]).length > 0 ? {
                           endAdornment: (
                               <InputAdornment position="end">
                                   <Tooltip title={(element[valPropName] as string[]).map(e => t(e)).join(' ')}
                                            interactive>
                                       <Error color="error"/>
                                   </Tooltip>
                               </InputAdornment>
                           ),
                       } : undefined}
            />
        );
    }

    shouldComponentUpdate(nextProps: Readonly<Props>, nextState: Readonly<{}>, nextContext: any): boolean {
        let propName = this.props.propName;
        let update = this.props.element[propName] !== nextProps.element[propName];
        if (update) {
            console.log("update reach text field (substanceId:%d, propName:%s)", this.props.svhc.id, this.props.propName);
        }
        return update;
    }
}

export default compose(
    withTranslation('common'),
)(ReachTextField) as any;